import { render, staticRenderFns } from "./DShareDownloadAlert.vue?vue&type=template&id=31399f06&scoped=true&"
import script from "./DShareDownloadAlert.vue?vue&type=script&lang=js&"
export * from "./DShareDownloadAlert.vue?vue&type=script&lang=js&"
import style0 from "./DShareDownloadAlert.vue?vue&type=style&index=0&id=31399f06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31399f06",
  null
  
)

export default component.exports